





























































































































































































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import _get from 'lodash/get'
import instance from '../store/connection'

@Component
export default class Employee extends Vue {
  moment = moment
  loading: boolean = false
  uploading: boolean = false
  fileuploading: boolean = false
  uploadingBatch: boolean = false
  modalVisible: boolean = false
  modalVisible2: boolean = false
  modalLoading: boolean = false
  modalLoading2: boolean = false
  modalTitle: string = 'Add Employee'
  uploaded1: boolean = false
  fileList: any[] = []
  columns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: true,
    },
    {
      title: 'Phone Number',
      dataIndex: 'mobile'
    },
    {
      title: 'Action',
      dataIndex: 'operation',
      fixed: 'right',
      width: 160,
      scopedSlots: { customRender: 'action' },
    },
  ]
  rules = {
    name: [
      { required: true, message: 'Name must not be empty', trigger: 'blur' },
    ],
    photo: [
      { required: true, message: 'Photo must not be empty', trigger: 'blur' },
    ],
    photoMethod: [
      { required: true, message: 'Photo Method must not be empty', trigger: 'blur' },
    ],
    pass_start: [
      { required: true, message: 'Start Time must not be empty', trigger: 'change' },
    ],
    pass_end: [
      { required: true, message: 'End Time must not be empty', trigger: 'change' },
    ],
  }
  form = {} as any
  isEdit: boolean = false
  totalEntry: number = 0
  totalPhotoEntry: number = 0
  batchList: {name: string, id: string}[] = []

  get role() {
    return this.$store.state.userStore.role
  }

  get employees() {
    return this.$store.state.employeeStore.employees 
  }

   get total() {
    return this.$store.state.employeeStore.total
  }

  get pagination() {
    return this.$store.state.employeeStore.pagination
  }

  get groups() {
    return this.$store.state.groupStore.groupList
  }

  get searchKey() {
    return this.$store.state.employeeStore.search
  }

  set searchKey(val) {
    this.$store.commit('updateEmployeeSearchKey', val)
  }

  get organizationList() {
    return this.$store.state.organizationStore.organizationList
  }

  get organization() {
    return this.$store.state.employeeStore.organization
  }

  set organization(val) {
    this.$store.commit('updateCurrentEmployeeOrg', val)
  }

  mounted() {
    this.loading = true
    this.$store.dispatch('listGroup')
    this.$store.dispatch('getEmployees', {
      page: this.pagination.current,
      limit: this.pagination.pageSize
    }).then(() => {
      this.loading = false
    })
    .catch(() => {
      this.loading = false
    })
  }

  updateEmployees(pagination:any, filters:any, sorter:any) {
    this.loading = true
    this.$store.commit('updateEmployeePagination', {current: pagination.current})
    this.$store.commit('updateEmployeeSorter', {field: sorter.field, order: sorter.order === 'ascend'? 'asc': 'desc'})
    this.$store.dispatch('getEmployees').then(() => {
      this.loading = false
    })
  }

  search() {
    this.loading = true
    this.$store.commit('updateEmployeePagination', {current: 1})
    this.$store.dispatch('getEmployees').then(() => {
      this.loading = false
    })
  }

  showCreateEmployee() {
    this.modalVisible = true
    this.modalTitle = 'Create Employee'
    this.isEdit = false
    const today = moment().format('YYYY-MM-DD HH:mm:ss')
    this.form = {
      photoMethod: 'path',
      pass_restrict: 0,
      pass_start: today,
      pass_end: today
    }
  }

  showCreateBulkEmployee() {
    this.modalVisible2 = true
  }

  showEditEmployee(employee: any) {
    this.form = { ...employee }
    this.modalTitle = 'Edit Employee'
    this.isEdit = true
    this.modalVisible = true
    this.form.pass_start = moment(this.form.pass_start)
    this.form.pass_end = moment(this.form.pass_end)
  }

  showDeletion(employee: any) {
    const h = this.$createElement
    const _this = this
    this.$confirm({
      title: 'Employee Delete',
      okText: 'Confirm',
      content: h('div', {}, [
        'Are you sure you want to delete ',
        h('strong', employee.name),
        '?'
      ]),
      onOk() {
        _this.$store.dispatch('deleteEmployee', employee.id)
      }
    })
  }

  saveEmployee() {
    this.modalLoading = true
    if (this.isEdit) {
      return this.$store.dispatch('updateEmployee', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("Employee Updated")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(JSON.stringify(_get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
    else {
      return this.$store.dispatch('addEmployee', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("Employee Created")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(JSON.stringify(_get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
  }

  cancelForm() {
    this.modalVisible = false
    this.modalLoading = false
    this.uploading = false
    this.form = {}
  }

  beforeUpload(file: {type: string, size: number}) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('You can only upload image file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  }

  uploadChanged(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
      return;
    }
    if (info.file.status === 'done') {
      this.form.photo = _get(info, 'file.response.path');
      this.uploading = false;
      return;
    }
  }

  async upload({ onSuccess, onError, file }:any) {
    const form = new FormData();
    form.append('photo', file)
    try {
      const result = await instance.post('/upload', form, { headers: {
        'Content-Type': 'multipart/form-data'
      }})
      if (_get(result, 'path' ,'')) {
        onSuccess(result)
      }
      else {
        onError('Path not found')
      }
    }
    catch (e) {
      onError(e);
    }
  }

  uploadFileChanged(info: any) {
    let fileList = [...info.fileList]
    this.fileList = fileList.filter(o => o.status !== 'error')
  }

  async uploadFile({ onSuccess, onError, file }:any) {
    this.fileuploading = true
    const form = new FormData();
    form.append('batch', file)
    if (this.organization) {
      form.append('organization', this.organization);
    }
    try {
      const result = await instance.post('/employee/batch', form, { headers: {
        'Content-Type': 'multipart/form-data'
      }})
      if (_get(result, 'success', false)) {
        this.uploaded1 = true
        onSuccess(result)
        this.loading = true
        this.$store.dispatch('getEmployees', {
          page: this.pagination.current,
          limit: this.pagination.pageSize
        }).then(() => {
        this.totalEntry = _get(result, 'total', 0)
        this.batchList = _get(result, 'employees', [])
        this.loading = false
        })
      }
      else {
        this.$message.error('Invalid Response')
        onError('Invalid Response')
      }
    }
    catch (e) {
      this.$message.error(_get(e, 'response.data.error', 'Something went wrong'))
      onError(e);
    }
    this.fileuploading = false
  }

  beforeBatchUpload(file: {type: string, size: number, name: string}) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('You can only upload image file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error('Image must smaller than 2MB!');
    }
    const isMatch = this.batchList.some(o => o.name === file.name.split('.')[0])
    if (!isMatch) {
      this.$message.error('Image name not match with uploaded list!');
    }
    return isJpgOrPng && isLt2M && isMatch;
  }

  uploadBatchChanged(info: any) {
    if (info.file.status === 'uploading') {
      this.uploadingBatch = true;
      return;
    }
    if (info.file.status === 'done') {
      const employee = this.batchList.find(o => o.name === info.file.name.split('.')[0])
      if (employee) {
        instance.put('/employee/' + employee.id, {photo: _get(info, 'file.response.path', ''), photoMethod: 'path'})
        this.totalPhotoEntry++
      }
      this.uploadingBatch = false;
      return;
    }
  }

  closeBulkUpload() {
    this.search()
    this.modalVisible2 = false
  }

}
